var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-fast"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }